export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            投稿爆料
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            你有独家消息？欢迎投稿爆料，让我们一起见证每一个精彩瞬间
          </p>
        </div>

        <div className="max-w-[700px] mx-auto bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/60">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-8">
            <div className="text-center p-4">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-3">
                <i className="ri-mail-line text-2xl"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">爆料邮箱</div>
              <div className="text-sm font-semibold text-foreground-900">tips@51chigua.com</div>
            </div>
            <div className="text-center p-4">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-50 text-accent-500 mb-3">
                <i className="ri-wechat-line text-2xl"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">微信客服</div>
              <div className="text-sm font-semibold text-foreground-900">51chigua_wx</div>
            </div>
            <div className="text-center p-4">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-3">
                <i className="ri-chat-1-line text-2xl"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">在线留言</div>
              <div className="text-sm font-semibold text-foreground-900">网站内提交</div>
            </div>
          </div>

          <div className="bg-background-100 rounded-xl p-5 text-center">
            <p className="text-xs md:text-sm text-foreground-600 mb-4">
              我们承诺对所有投稿者身份信息严格保密，采用匿名化处理
            </p>
            <div className="flex flex-wrap items-center justify-center gap-2 text-xs text-foreground-400">
              <span className="flex items-center gap-1">
                <i className="ri-shield-check-line text-primary-500"></i>
                隐私保护
              </span>
              <span className="mx-2">|</span>
              <span className="flex items-center gap-1">
                <i className="ri-speed-line text-primary-500"></i>
                快速响应
              </span>
              <span className="mx-2">|</span>
              <span className="flex items-center gap-1">
                <i className="ri-star-line text-primary-500"></i>
                首页推荐
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}